// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.waitlist.RentalManagerUserPropertyWaitlistWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface DisableParams {
  customerId: string;
  listingAlias: ListingAlias;
}
interface EnableParams {
  customerId: string;
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyWaitlistWebApiHandler_disable_Path =
  '/api/web/v1/users/properties/waitlist/disable';

/**
 * Disable waitlist feature for a property
 */
export const RentalManagerUserPropertyWaitlistWebApiHandler_disable = (
  getParams: DisableParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DisableParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyWaitlistWebApiHandler_disable_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyWaitlistWebApiHandler_enable_Path =
  '/api/web/v1/users/properties/waitlist/enable';

/**
 * Enable waitlist feature for a property
 */
export const RentalManagerUserPropertyWaitlistWebApiHandler_enable = (
  getParams: EnableParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<EnableParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyWaitlistWebApiHandler_enable_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
